var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticStyle: { top: "20px", height: "95%" },
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        keyboard: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        id: _vm.prefixNo,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _vm.checkFlag && _vm.isCanCheck
            ? _c(
                "a-button",
                {
                  attrs: { loading: _vm.confirmLoading },
                  on: { click: _vm.handleOkAndCheck },
                },
                [_vm._v("保存并审核")]
              )
            : _vm._e(),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleOkOnly },
            },
            [_vm._v("保存（Ctrl+S）")]
          ),
          !_vm.checkFlag
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleWorkflow()
                    },
                  },
                },
                [_vm._v("提交流程")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "客户",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "organId",
                                    _vm.validatorRules.organId,
                                  ],
                                  expression:
                                    "[ 'organId', validatorRules.organId ]",
                                },
                              ],
                              attrs: {
                                placeholder: "请选择客户",
                                dropdownMatchSelectWidth: false,
                                showSearch: "",
                                optionFilterProp: "children",
                              },
                              on: {
                                change: _vm.onChangeOrgan,
                                search: _vm.handleSearchCustomer,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "dropdownRender",
                                  fn: function (menu) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-nodes", {
                                          attrs: { vnodes: menu },
                                        }),
                                        _c("a-divider", {
                                          staticStyle: { margin: "4px 0" },
                                        }),
                                        _vm.quickBtn.customer
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-btn",
                                                on: {
                                                  mousedown: (e) =>
                                                    e.preventDefault(),
                                                  click: _vm.addCustomer,
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "plus" },
                                                }),
                                                _vm._v(" 新增客户"),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-btn",
                                            on: {
                                              mousedown: (e) =>
                                                e.preventDefault(),
                                              click: _vm.initCustomer,
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "reload" },
                                            }),
                                            _vm._v(" 刷新"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ]),
                            },
                            _vm._l(_vm.cusList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.supplier) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据日期",
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "billTime",
                                  _vm.validatorRules.billTime,
                                ],
                                expression:
                                  "['billTime', validatorRules.billTime]",
                              },
                            ],
                            attrs: { "show-time": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据编号",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["billNo", _vm.validatorRules.billNo],
                                expression:
                                  "[ 'billNo', validatorRules.billNo ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入单据编号" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "财务人员",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["handsPersonId"],
                                  expression: "[ 'handsPersonId' ]",
                                },
                              ],
                              attrs: {
                                placeholder: "请选择财务人员",
                                dropdownMatchSelectWidth: false,
                                showSearch: "",
                                optionFilterProp: "children",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "dropdownRender",
                                  fn: function (menu) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-nodes", {
                                          attrs: { vnodes: menu },
                                        }),
                                        _c("a-divider", {
                                          staticStyle: { margin: "4px 0" },
                                        }),
                                        _vm.quickBtn.person
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-btn",
                                                on: {
                                                  mousedown: (e) =>
                                                    e.preventDefault(),
                                                  click: _vm.addPerson,
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "plus" },
                                                }),
                                                _vm._v(" 新增经手人"),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-btn",
                                            on: {
                                              mousedown: (e) =>
                                                e.preventDefault(),
                                              click: _vm.initPerson,
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "reload" },
                                            }),
                                            _vm._v(" 刷新"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ]),
                            },
                            _vm._l(_vm.personList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  loading: _vm.accountTable.loading,
                  columns: _vm.accountTable.columns,
                  dataSource: _vm.accountTable.dataSource,
                  minWidth: _vm.minWidth,
                  maxHeight: 300,
                  rowNumber: true,
                  rowSelection: true,
                  actionButton: false,
                  actionDeleteButton: true,
                },
                on: { deleted: _vm.onDeleted, valueChange: _vm.onValueChange },
                scopedSlots: _vm._u([
                  {
                    key: "buttonBefore",
                    fn: function () {
                      return [
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              float: "left",
                              "padding-bottom": "8px",
                            },
                            attrs: { gutter: 24 },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 12, sm: 24 } },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "plus" },
                                    on: { click: _vm.handleClickAdd },
                                  },
                                  [_vm._v("选择单据")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              {
                                staticStyle: { "padding-left": "0" },
                                attrs: { md: 12, sm: 24 },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", icon: "plus" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectBeginNeed("客户")
                                      },
                                    },
                                  },
                                  [_vm._v("选择期初")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "buttonAfter",
                    fn: function () {
                      return [
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              float: "left",
                              "padding-bottom": "8px",
                            },
                            attrs: { gutter: 24 },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 12, sm: 24 } },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { icon: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleWaitNeed("客户")
                                      },
                                    },
                                  },
                                  [_vm._v("待收款")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 24, md: 24, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
                            label: "",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["remark"],
                                expression: "[ 'remark' ]",
                              },
                            ],
                            staticStyle: { "margin-top": "8px" },
                            attrs: { rows: 2, placeholder: "请输入备注" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "收款账户",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "accountId",
                                    _vm.validatorRules.accountId,
                                  ],
                                  expression:
                                    "[ 'accountId', validatorRules.accountId ]",
                                },
                              ],
                              attrs: {
                                placeholder: "请选择收款账户",
                                dropdownMatchSelectWidth: false,
                                showSearch: "",
                                optionFilterProp: "children",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "dropdownRender",
                                  fn: function (menu) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-nodes", {
                                          attrs: { vnodes: menu },
                                        }),
                                        _c("a-divider", {
                                          staticStyle: { margin: "4px 0" },
                                        }),
                                        _vm.quickBtn.account
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-btn",
                                                on: {
                                                  mousedown: (e) =>
                                                    e.preventDefault(),
                                                  click: _vm.addAccount,
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "plus" },
                                                }),
                                                _vm._v(" 新增"),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-btn",
                                            on: {
                                              mousedown: (e) =>
                                                e.preventDefault(),
                                              click: _vm.initAccount,
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "reload" },
                                            }),
                                            _vm._v(" 刷新"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ]),
                            },
                            _vm._l(_vm.accountList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "合计收款",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["totalPrice"],
                                expression: "[ 'totalPrice' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              placeholder: "请输入合计收款",
                              readOnly: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "优惠金额",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: [
                                  "discountMoney",
                                  _vm.validatorRules.discountMoney,
                                ],
                                expression:
                                  "[ 'discountMoney', validatorRules.discountMoney ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入优惠金额" },
                            on: { change: _vm.onChangeDiscountMoney },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "实际收款",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["changeAmount"],
                                expression: "[ 'changeAmount' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              placeholder: "请输入实际收款",
                              readOnly: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "附件",
                          },
                        },
                        [
                          _c("j-upload", {
                            attrs: { bizPath: "financial" },
                            model: {
                              value: _vm.fileList,
                              callback: function ($$v) {
                                _vm.fileList = $$v
                              },
                              expression: "fileList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("debt-bill-list", {
        ref: "debtBillList",
        on: { ok: _vm.debtBillListOk },
      }),
      _c("customer-modal", {
        ref: "customerModalForm",
        on: { ok: _vm.customerModalFormOk },
      }),
      _c("account-modal", {
        ref: "accountModalForm",
        on: { ok: _vm.accountModalFormOk },
      }),
      _c("person-modal", {
        ref: "personModalForm",
        on: { ok: _vm.personModalFormOk },
      }),
      _c("wait-need-list", {
        ref: "waitNeedList",
        on: { ok: _vm.waitNeedListOk },
      }),
      _c("workflow-iframe", {
        ref: "modalWorkflow",
        on: { ok: _vm.workflowModalFormOk },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }